/** @module AuthAnalyticsConstants */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

/**
 * Shared constants for analytics events, steps, flows, and surfaces
 * This file contains ONLY constants - no logic or classes
 * Can be safely imported by any module without circular dependency concerns
 */

// Constants for surfaces
export const SURFACE_AUTH = 'ShipStation Centralized Auth';

// Constants for flows
export const FLOW_SIGN_IN = 'Sign In Flow';
export const FLOW_PASSWORD_RESET = 'Password Reset Flow';

// Constants for steps
export const STEP_LOGIN_PAGE = 'Login Page';
export const STEP_START_CHANGE_PASSWORD_PAGE = 'Start Change Password Page';
export const STEP_CHANGE_PASSWORD_PAGE = 'Change Password Page';
export const STEP_CHOOSE_MFA_FACTOR_PAGE = 'Choose MFA Factor Page';
export const STEP_MFA_CODE_ENTRY_PAGE = 'MFA Code Entry Page';

// Constants for event names - Login page
export const EVENT_LOGIN_SSO_BUTTON_CLICKED = 'Login Page SSO Button Clicked';
export const EVENT_LOGIN_BUTTON_CLICKED = 'Login Button Clicked';
export const EVENT_LOGIN_FORGOT_PASSWORD_CLICKED = 'Login Page Forgot Password Clicked';
export const EVENT_LOGIN_USERNAME_ENTERED = 'Login Page Username Entered';
export const EVENT_LOGIN_PASSWORD_ENTERED = 'Login Page Password Entered';
export const EVENT_LOGIN_REMEMBER_ME_TOGGLED = 'Login Page Remember Me Toggled';
export const EVENT_LOGIN_SUCCESS = 'Login Success';
export const EVENT_LOGIN_FAILED = 'Login Failed';

// Constants for event names - Password reset/change page
export const EVENT_CHANGE_PASSWORD_FLOW_STARTED = 'Change Password Flow Started';
export const EVENT_CHANGE_PASSWORD_BUTTON_CLICKED = 'Change Password Button Clicked';
export const EVENT_CHANGE_PASSWORD_SUCCESS = 'Change Password Success';
export const EVENT_CHANGE_PASSWORD_FAILED = 'Change Password Failed';
export const EVENT_CHANGE_PASSWORD_CANCEL = 'Change Password Cancelled';
export const EVENT_CHANGE_PASSWORD_NEW_PASSWORD_ENTERED = 'Change Password New Password Entered';
export const EVENT_CHANGE_PASSWORD_CONFIRMATION_ENTERED = 'Change Password Confirmation Entered';
export const EVENT_CHANGE_PASSWORD_EMAIL_ENTERED = 'Change Password Email Entered';

// Constants for event names - MFA pages
export const EVENT_MFA_FACTOR_SELECTED = 'MFA Factor Selected';
export const EVENT_MFA_CODE_ENTERED = 'MFA Code Entered';
export const EVENT_MFA_CODE_SUBMITTED = 'MFA Code Submitted';
export const EVENT_MFA_CODE_RESEND_REQUESTED = 'MFA Code Resend Requested';
export const EVENT_MFA_PASSWORD_SUBMITTED = 'MFA Password Submitted';
export const EVENT_MFA_VERIFICATION_SUCCESS = 'MFA Verification Success';
export const EVENT_MFA_VERIFICATION_FAILED = 'MFA Verification Failed';
export const EVENT_MFA_CANCEL = 'MFA Cancelled';

// Defaults
export const DEFAULT_AUTH_PROVIDER = 'ShipStation IdentityService';
